import axios from "axios";
const url = process.env.REACT_APP_ENDPOINT;

const AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_ENDPOINT,
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

AxiosInstance.interceptors.request.use(
    config => {
        const access_token = localStorage.getItem('access_token');
        if (access_token) {
            config.headers['Authorization'] = 'Bearer ' + access_token
        }
        return config;
    },
    error => {
        Promise.reject(error.response || error.message)
    }
);

AxiosInstance.interceptors.response.use(
    response => {
        return response;
    },
    async error => {
        let originalRequest = error.config;

        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = localStorage.getItem('refresh');
            return axios.post(`${url}users/token/refresh/`, { 'refresh': refreshToken })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        localStorage.setItem('access_token', response.data.access);
                        localStorage.setItem('refresh', response.data.refresh);
                        originalRequest.headers['Authorization'] = `Bearer ${response.data.accessToken}`;
                        return axios(originalRequest);
                    }
                })
                .catch((error) => {
                    localStorage.clear();
                    window.location.reload();
                })
        }
        return Promise.reject(error.response || error.message);
    })

export default AxiosInstance
